module.exports = __webpack_public_path__ + "static/person-2.208f3a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/medicare/person-2.png
// module id = 3718
// module chunks = 129662963943619